import React, { useEffect, useMemo, useRef, useState } from 'react';
import ProfileCard from '../../component/cards/new/ProfileCard';
import { ContentWrapper, PageWrapper } from '../../globalStyles';
import { ReactComponent as FemaleAvatar } from '../../assests/avatarFemale.svg'
import { ReactComponent as MaleAvatar } from '../../assests/avatarMale.svg'
import SearchWithFilter from '../../component/search/SearchWithFilter';
import ProfileCardWrapper from '../../component/cards/new/ProfileCardWrapper';
import SearchWorker from '../../workers/search.worker.js';
import { Users } from 'lucide-react';
import FilterDropdown from '../../component/search/FilterDropdown.js';
import { PageConfig } from '../../configure/PathConfig.js';
import { useNavigate, useParams } from 'react-router-dom';
import { API_ROUTES, apiPost } from '../../configure/apiConfig.js';
import { LoaderComponent } from '@auth/PrivateRoute';
import TabList from './components/TabList';
import { useDispatch } from 'react-redux';
import TabTable from './components/tabtable';
import { setPath } from '@redux/slices/BreadCrumbsSlice';
import { formatString } from '@utils/dataformatter/Rawformatter';
import axios from 'axios';
import Nodata from '@component/NodataTailwind';
import { FullScreenWrapper, useFullScreen } from '@component/fullscreen/FullScreenWrapper';
import { ACCESSPERMISSION } from '@common/lang/locale/MenueditPath';
import useHasEditPermission from '@utils/RbacUtils';
import { exportFile, exportFileFormat, exportFilesDataMatch } from '@utils/exportFile';
import { toast } from '@/hooks/use-toast';
import CustomModal from "../../component/Buttons/ButtonValidation";
import { convertMonthsToYears } from '@component/formfields/EditFormTailwind';
import ExportModal from '@/components/ui/ExportModal';
import { STRUCTURE } from '@utils/exportFileStructure';
import ColumnsFilterPopup from '@/components/ui/ColumnsFilterPopup';
import { getBandLabel } from '@utils/bandFormatter';

// utils/statusMapper.js
export const getStatusMeta = (allocationStatus) => {
  switch (allocationStatus?.trim()) {
    case 'P':
      return { status: 'Partial', color: '#f6ac19', bg: '#facc1533' };
    case 'Y':
      return { status: 'Full', color: 'red', bg: '#f6c8c8' };
    case 'N':
      return { status: 'Available', color: '#4aa785', bg: '#def8ee' };
    default:
      return { status: '', color: '' };
  }
};

const getUtilizedStatus = (percent) => {
  // Numeric handling
  let value = Number(percent);

  if (!value) value = 0; // if null, undefined, empty, NaN → treat as 0

  if (value === 100) return { percentage: `${value}`, bgColor: '#16a249' }; // green
  if (value >= 1 && value <= 99) return { percentage: `${value}`, bgColor: '#f6ac19' }; // orange
  if (value > 100) return { percentage: `${value}`, bgColor:'red'} // red

  return { percentage: '0', bgColor: 'blue' }; // zero
};


function ExportModalWrapper(props) {
  const { wrapperRef } = useFullScreen();

  return (
    <ExportModal
    list={props.exportList}
    open={props.openDownloadModal}
    onCancel={props.handleExportClose}
    onAccept={props.handleExportConfirm}
    header="Are you sure you want to export?"
    cancelText="Cancel"
    acceptText="OK"
    containerRef={wrapperRef}
    />
  );
}



function PeopleToolbar(props) {
  const { toggleFullscreen, isFullscreen } = useFullScreen()
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-3 mt-2 flex-wrap">
      {/* Left Section: Search + Filters */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto flex-wrap">
        {/* Search with Filters */}
        <div className="relative w-full sm:w-auto">
          <SearchWithFilter.SearchBar
            value={props.search}
            onChange={(e) => props.setSearch(e.target.value)}
            onSearch={props.onSearch}
            onToggleFilter={() => props.setShowFilters((prev) => !prev)}
            filterCount={Object.values(props.selectedFilters).flat().length}
            isVisibleBtn={false}
            isfilterVisible={props.toggleView === 'Grid'}
          />
          {props.showFilters && (
            <div
              ref={props.filterRef}
              className="absolute top-full left-[60%] mt-2 z-50 w-[250px]"
            >
              <FilterDropdown
                data={props.filteredPeople}
                filterKeys={props.filterFields}
                filterLabels={props.filterLabels}
                selectedFilters={props.tempFilters}
                setSelectedFilters={props.setTempFilters}
                onSearch={props.onSearch}
                onApply={(selected) => {
                  props.setSelectedFilters(selected);
                  const filtered = props.filteredPeople.filter((p) =>
                    Object.entries(selected).every(([key, values]) => {
                      let val = p[key];
                      if (["total_yoe", "wavicle_yoe", "yoe_before_wavicle"].includes(key)) {
                        val = convertMonthsToYears(val);
                      }
                      return values.length === 0 || values.includes(val);
                    })
                  );
                  props.setFilteredPeople(filtered);
                  props.setShowFilters(false);
                }}
                onClear={() => {
                  props.setTempFilters({});
                  props.setSelectedFilters({});
                  props.setFilteredPeople(props.filteredPeople);
                }}
                isLoading={props.isLoading}
              />
            </div>
          )}
        </div>
        {/* Tabs Filter */}
        <div className="relative w-full sm:w-auto">
          <SearchWithFilter.SearchBar
            isSearchVisible={false}
            isVisibleFilterIcon={true}
            filtername={
              props.selectedTab.key === "all_resources"
                ? "Predefined filters"
                : props.selectedTab.label
            }
            onToggleFilter={() => props.setShowTab((prev) => !prev)}
          />
          {props.showTab && (
            <div
              ref={props.filterRef}
              className="absolute top-full left-0 mt-2 z-50 w-[250px]"
            >
              <TabList
                data={props.tabs}
                filterKeys={["label"]}
                selectedFilters={{
                  label: props.selectedTab.label,
                }}
                setSelectedFilters={(filters) => {
                  props.setSelectedTab(filters);
                }}
                onApply={(selected) => {
                  const selectedKey =
                    Object.values(selected)[0] || "all_resources";
                  props.handleTabChange(selectedKey);
                  props.setShowTab(false);
                  props.setIsPassSelecetdTab(props.selectedTab);
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Right Section: View Toggle */}
      <div className="w-full sm:w-auto flex items-center justify-end gap-2">
        <div className="relative w-full sm:w-auto">
          <SearchWithFilter.Exporticon onClick={props.handleExport} isLoading={props.isLoading}/>
        </div>
        <SearchWithFilter.FullScreenToggle
          toggleView={props.toggleView}
          toggleFullscreen={toggleFullscreen}
          isFullscreen={isFullscreen}
        />
        {props.toggleView  === 'table'&&<ColumnsFilterPopup data={props?.columnsData} handleApply={(v)=>props.setColumnVisibility(v)} columnVisibility={props?.columnVisibility} disabled={props?.isLoading}/>}
        {!isFullscreen && (<>
          <SearchWithFilter.ViewToggle
            value={props.toggleView}
            onChange={props.handleToggle}
          />
        </>
        )}
      </div>
    </div>
  );
}

const RMPeople = () => {
  const [search, setSearch] = useState('');
  const [toggleView, setToggleView] = useState('Grid');
  const workerRef = useRef(null);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const filterFields = ['employeeid', 'fullname', 'rolename', 'employmenttype', 'band_', 'departmentname',
    'managername', 'status_', 'allocation_status', 'category', 'employee_location', 'end_date',
    'start_date', 'total_yoe', 'wavicle_yoe', 'work_email', 'yoe_before_wavicle', 'project_end_date',];
  const filterRef = useRef(null);
  const navigate = useNavigate();
  const currentTabIndex = 1;
  const [profileData, setProfileData] = useState([]);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const [pageSize, setPageSize] = useState(7);
  const [isLoading, setIsLoading] = useState(true);
  const [showTab, setShowTab] = useState(false);
  const [selectedTab, setSelectedTab] = useState({ key: "all_resources" || "All Tabs" });
  const dispatch = useDispatch();
  const [oldTable, setOldTable] = useState(false)
  const [tabValueCounts, setTabValueCounts] = useState({ count: 100 });
  const [isPassSelectedTab, setIsPassSelecetdTab] = useState({ label: "all_resources" || "All Tabs" });
  const [showAll, setShowAll] = useState(false);
  const [tabDataCount, setTabDataCount] = useState([])
  const [expandedBadges, setExpandedBadges] = useState({});
  const [tempFilters, setTempFilters] = useState({});
  const [loading, setLoading] = useState({ clear: false });
  const isAuthenticated = useHasEditPermission(ACCESSPERMISSION.RM_PEOPLE_EDIT);
  const tableforwardref = useRef();
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [notesLoader, setNotesLoader] = useState({})
  const [refData,setRefData] = useState(null)

  const [exportList, setExportList] = useState(STRUCTURE.PEOPLE.all);
  const [columnVisibility , setColumnVisibility] = useState({"Work Email":false});
      const [columnsData,setColumnsData] = useState([])


useEffect(() => {
    if (tableforwardref?.current || profileData.length) {
     setExportList(exportFilesDataMatch(exportList,tableforwardref?.current?.getData()?.[0]?.original || profileData?.[0] || []))
    }
  }, [tableforwardref?.current ,profileData])




useEffect(() => {
    const columns = refData?.getAllLeafColumns?.() || []
   setColumnsData(columns)
  if (columns.length) {
    const obj = {};
    columns.forEach((v) => {
      obj[v.id] = columnVisibility?.[v.id] ?? true;
    });
    setColumnVisibility(obj);
  }
}, [refData]);


  const filterLabels = {
    employeeid: "Employee ID",
    fullname: "Full Name",
    rolename: "Role Name",
    employmenttype: "Employment Type",
    band_: "Band",
    departmentname: "Department",
    managername: "Manager/ Mentor",
    status_: "Status",
    allocation_status: "Allocation Status",
    category: "Category",
    employee_location: "Employee Location",
    end_date: "End Date",
    start_date: "Start Date",
    total_yoe: "Total YOE",
    wavicle_yoe: "Wavicle YOE",
    work_email: "Work Email",
    yoe_before_wavicle: "YOE Before Wavicle",
    project_end_date: "Projected Roll Off Date",
  };
  const { currentTab } = useParams();
  const path = [
    { label: "Resource Management", url: "" },
    { label: "People", url: "" },
  ];

  // keep tabs array same
  const tabs = [
    { key: "all_resources", label: "All Resources", count: tabDataCount.total_res_count },
    { key: "manager", label: "Manager", count: tabDataCount.manager_res_count },
    { key: "inprojects", label: "In Projects", count: tabDataCount.in_proj_res_count },
    { key: "inbench", label: "In Bench", count: tabDataCount.inbench_res_count },
    { key: "approach_bench", label: "Approach Bench", count: tabDataCount.appr_bench_res_count },
    { key: "full_time_employee", label: "Full Time Employee", count: tabDataCount.full_time_res_count },
    { key: "contractor", label: "Contractor", count: tabDataCount.contractor_res_count },
    { key: "leadership", label: "Leadership", count: tabDataCount.ldrshp_res_count },
    { key: "india_people", label: "India People", count: tabDataCount.india_res_count },
    { key: "us_people", label: "US People", count: tabDataCount.us_res_count },
    { key: "canada_people", label: "Canada People", count: tabDataCount.can_res_count },
  ];
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const handleExportClose = () => {
    setOpenDownloadModal(false)
  }

  const handleExportConfirm = (list=[]) => {
        const status ={
            Y : "Full",
            N : "Available",
            P : "Partial"
        }
    let dataToExport;

    if (toggleView === "table" && tableforwardref?.current) {
      // ✅ get table data from tableforwardref
      const tableRows = tableforwardref.current.getData();
      dataToExport = tableRows.map((row) => row.original);
      console.log("Exporting from tableRef:", dataToExport);
    } else {
      // ✅ if filters/search applied, use filteredPeople else all profileData
      dataToExport =
        Object.keys(selectedFilters).length > 0 || search.trim().length > 0
          ? filteredPeople
          : profileData;
      console.log("Exporting from filter/search:", dataToExport);
    }

    // 🚨 check if no data
    if (!dataToExport || dataToExport.length === 0) {
      toast({
        description: "No data available to export",
        title: "Warning",
        variant: "destructive",
      });
      return;
    }

    const fileName = `rmpeople_${currentTab}`;

    try {
      const changeListForStatus = dataToExport.map((item) => {
            return {
                ...item,
                allocation_status: status?.[item.allocation_status] || item.allocation_status,
                status_:item?.status_ === 'FALSE' ? 'Inactive' : 'Active',
            };
        });
      const resultsExport = exportFileFormat(list, changeListForStatus);
      exportFile("csv", resultsExport, fileName);
      toast({ description: "Successfully Exported", title: "Success" });
    } catch (err) {
      console.error("Export failed:", err);
      toast({
        description: "Export failed",
        title: "Error",
        variant: "destructive",
      });
    }

    setOpenDownloadModal(false);
  };


  const [activeTab, setActiveTab] = useState("all_resources");

  // effect to sync with route
  useEffect(() => {
    dispatch(setPath(path));

    // find the tab object that matches route param
    const matchedTab =
      tabs.find((tab) => formatString(tab.key) === formatString(currentTab)) ||
      tabs[0]; // fallback to "all_resources"

    setActiveTab(matchedTab.key);     // ✅ API key
    setSelectedTab(matchedTab);
    setIsPassSelecetdTab(matchedTab)       // ✅ full object (label + key)
    getPeopleData(matchedTab.key);    // ✅ API call
  }, [currentTab]);

  useEffect(() => {
    getPeopleData(activeTab);
  }, [pageSize, activeTab]);

  // handler for View More
  const handleViewMore = () => {
    setPageSize((prev) => prev + 8); // increase limit
  };

  // navigation handler
  const handleTabChange = (value) => {
    setTempFilters({});
    setSelectedFilters({});
    setSearch('')
    // value will be a key (like "rm_sheet")
    const matchedTab =
      tabs.find((tab) => formatString(tab.key) === formatString(value)) ||
      tabs[0];

    setActiveTab(matchedTab.key);
    setSelectedTab(matchedTab);

    const newUrl = `${PageConfig.RM.PEOPLELANDING}/${matchedTab.key}`;
    navigate(newUrl);
  };

  const onClickRow = (employeeID) => {

    navigate(`${PageConfig["RM"].PROFILE}/${employeeID}`, {
      state: { employeeID, currentTabIndex },
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilters(false);
        setShowTab(false);
        setSelectedTab(tabs.find((tab) => formatString(tab.key) === formatString(currentTab)) ||
          tabs[0])
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentTab]);

  useEffect(() => {
    workerRef.current = new SearchWorker();
    workerRef.current.onmessage = (e) => {
      const { type, filteredData } = e.data;
      if (type === 'result') {
        setFilteredPeople(filteredData);
      }
    };
    return () => workerRef.current.terminate();
  }, []);

// 1️⃣ Handle search input change
const handleSearch = (value) => {
  setSearch(value);
};

// 2️⃣ Central logic: whenever search or filters or profileData changes
useEffect(() => {
  if (!profileData || profileData.length === 0) return;

  // Step 1: Apply filters
  let filtered = profileData;
  if (Object.keys(selectedFilters).length > 0) {
    filtered = profileData.filter((p) =>
      Object.entries(selectedFilters).every(([key, values]) => {
        let val = p[key];
        if (["total_yoe", "wavicle_yoe", "yoe_before_wavicle"].includes(key)) {
          val = convertMonthsToYears(val);
        }
        return values.length === 0 || values.includes(val);
      })
    );
  }

  // Step 2: Apply search (if not empty)
  if (search.trim() !== "") {
    if (workerRef.current) {
      workerRef.current.postMessage({
        action: "search",
        query: search.trim(),
        dataset: filtered, // 👈 search only within filtered data
        keys: [
          "employeeid",
          "fullname",
          "rolename",
          "employmenttype",
          "band_",
          "departmentname",
          "status_",
          "allocation_status",
          "category",
          "employee_location",
          "end_date",
          "start_date",
          "total_yoe",
          "wavicle_yoe",
          "work_email",
          "yoe_before_wavicle",
          "project_end_date",
        ],
      });
    }
  } else {
    // Step 3: If search cleared → show filtered data
    setFilteredPeople(filtered);
  }
}, [search, selectedFilters, profileData]);


  // toggle between Grid <-> Table
  const handleToggle = () => {
    setToggleView((prev) => {
      if (prev === "Grid") {
        // 👉 switching to Table
        setSelectedFilters({});
        setTempFilters({});
        setSearch("");                 // clear table search
        setFilteredPeople(profileData); // reset table data
        return "table";
      } else {
        // 👉 switching to Grid
        setSearch("");                 // clear search for Grid too
        setFilteredPeople(profileData); // reset Grid data
        return "Grid";
      }
    });
    setOldTable(false);
  };

  // toggle View More / View Less
  const handleToggleViewMore = async () => {
    setIsLoadingMore(true); // show loader immediately

    try {
      // If you're fetching from API, await that here
      // await getPeopleData(...); 
      // OR if it's just local slice (no API call), add a small delay so loader is visible
      await new Promise((resolve) => setTimeout(resolve, 300));

      setShowAll((prev) => !prev);
    } finally {
      setIsLoadingMore(false); // hide loader after data is ready
    }
  };


  const getPeopleData = async (type = "all_resources", loadingtype = 'default', employeeId = null) => {

    if (loadingtype === "notes" && employeeId) {
      setNotesLoader((prev) => ({ ...prev, [employeeId]: true }));
    } else {
      setIsLoading(true);
    }
    try {
      const response = await apiPost(
        API_ROUTES.GET_PEOPLE_RM,
        {
          tabType: type || "all_resources",
          pageNumber: 1,
          pageSize: 100000,
          sortColumn: "",
          sortType: "",
          columnSearchFilter: "",
          columnSearchFilterValue: "",
          filterParams: {},
        },
        "get-people-data"
      );

      if (response.status === 200) {
        const data = response?.data?.data?.peopleData;
        console.log(response);

        setProfileData(data);
        // setFilteredPeople(data);
        if (Object.keys(selectedFilters).length > 0) {
          const filtered = data.filter((p) =>
            Object.entries(selectedFilters).every(
              ([key, values]) => values.length === 0 || values.includes(p[key])
            )
          );
          setFilteredPeople(filtered);
        } else {
          setFilteredPeople(data);
        }
        if (loadingtype === "notes" && employeeId) {
          setNotesLoader((prev) => ({ ...prev, [employeeId]: false }));
        }
        setIsLoading(false)
        if (loadingtype === 'default') {
          setShowAll(false);
        }
        setTabDataCount(response?.data?.data?.get_all_resource_type_count)
      }

    } catch (error) {
      console.error(error);
      const isCancelled = axios.isCancel(error);
      if (isCancelled) {
        setIsLoading(true)
        return
      }
      else if (loadingtype === "notes" && employeeId) {
        setNotesLoader((prev) => ({ ...prev, [employeeId]: false }));
      }
      setIsLoading(false)
    }
    // finally {
    //   if (loadingtype === "notes" && employeeId) {
    //     setNotesLoader((prev) => ({ ...prev, [employeeId]: false }));
    //   } else {
    //     setIsLoading(false);
    //   }
    // }
  };

  // Add loading state for clearing filters

  const handleRemoveFilter = async (key, value) => {
    setLoading((prev) => ({ ...prev, clear: true }));
    try {
      setSelectedFilters((prev) => {
        const updatedValues = (prev[key] || []).filter((v) => v !== value);
        const newFilters = { ...prev, [key]: updatedValues };
        const filtered = profileData.filter((p) =>
          Object.entries(newFilters).every(([fKey, fValues]) => {
            let val = p[fKey];
            if (["total_yoe", "wavicle_yoe", "yoe_before_wavicle"].includes(fKey)) {
              val = convertMonthsToYears(val);
            }
            return fValues.length === 0 || fValues.includes(val);
          })
        );
        setFilteredPeople(filtered);
        return newFilters;
      });

      setTempFilters((prev) => {
        const updatedValues = (prev[key] || []).filter((v) => v !== value);
        return { ...prev, [key]: updatedValues };
      });
    } finally {
      setLoading((prev) => ({ ...prev, clear: false }));
    }
  };

  const isFilterVisible = toggleView === "Grid";
  const getInitials = (name) => {
    if (!name) return "N/A";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0][0].toUpperCase();
    return (
      (words[0][0] || "") + (words[words.length - 1][0] || "")
    ).toUpperCase();
  };
  return (
    <PageWrapper className='!overflow-y-hidden !bg-background'>
      <ContentWrapper>
        <div className='min-h-[80vh] w-full'>
          <FullScreenWrapper>
            <div className='flex flex-col w-full gap-3'>
              <SearchWithFilter>
                <SearchWithFilter.Title icon={<Users fontSize="large" />} />

                {/* Responsive Toolbar */}
                <PeopleToolbar
                  search={search}
                  setSearch={setSearch}
                  toggleView={toggleView}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                  selectedFilters={selectedFilters}
                  isfilterVisible={isFilterVisible}
                  setSelectedFilters={setSelectedFilters}
                  tempFilters={tempFilters}
                  setTempFilters={setTempFilters}
                  filterFields={filterFields}
                  filterLabels={filterLabels}
                  filterRef={filterRef}
                  profileData={profileData}
                  setFilteredPeople={setFilteredPeople}
                  isLoading={isLoading}
                  showTab={showTab}
                  setShowTab={setShowTab}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  oldTable={oldTable}
                  setIsPassSelecetdTab={setIsPassSelecetdTab}
                  tabs={tabs}
                  handleTabChange={handleTabChange}
                  onSearch={() => handleSearch(search)}
                  handleToggle={handleToggle}
                  handleExport={() => setOpenDownloadModal(true)}
                  filteredPeople={filteredPeople}
                  columnsData={columnsData}
                  columnVisibility={columnVisibility}
                  setColumnVisibility={setColumnVisibility}
                ></PeopleToolbar>
              </SearchWithFilter>
              {isLoading ? (
                <LoaderComponent showText={false} />
              ) : toggleView === "Grid" ? (
                <div className="w-full h-[80%]">
                  {/* Selected Filters Badges */}
                  {Object.entries(selectedFilters).some(([_, values]) => values.length > 0) && (
                    <div
                      className="flex flex-wrap gap-3 mb-3 max-h-[6rem] overflow-y-auto pr-2"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      {Object.entries(selectedFilters).map(([key, values]) => {
                        if (!values.length) return null;

                        const isExpanded = expandedBadges[key] || false;
                        const visibleValues = isExpanded ? values : values.slice(0, 3);
                        const remainingCount = values.length - visibleValues.length;

                        const formatValue = (val) => {
                          const trimmedVal = typeof val === "string" ? val.trim() : val;
                          if (trimmedVal === -1) return "Contractor";
                          if (trimmedVal === " ") return "N/A";
                          if (trimmedVal === "TRUE") return "Active";
                          if (trimmedVal === "FALSE") return "In-Active";
                          if (trimmedVal === "P") return "Partial";
                          if (trimmedVal === "Y") return "Full-Time";
                          if (trimmedVal === "N") return "Available";
                          if (!trimmedVal) return "N/A";

                          return val;
                        };
                        return (
                          <div key={key} className="flex items-center gap-2 flex-wrap">
                            <span className="text-sm font-semibold text-gray-600 dark:text-gray-300">
                              {filterLabels[key] || key}:
                            </span>

                            {visibleValues.map((val) => (
                              <span
                                key={`${key}-${val}`}
                                className="inline-flex items-center bg-primary/10 text-foreground text-xs font-medium px-3 py-1 rounded-full"
                              >
                                {formatValue(val)}
                                <button
                                  onClick={() => handleRemoveFilter(key, val)}
                                  className="ml-2 text-foreground font-bold"
                                >
                                  ×
                                </button>
                              </span>
                            ))}

                            {/* Show More / Show Less */}
                            {remainingCount > 0 && !isExpanded && (
                              <button
                                onClick={() =>
                                  setExpandedBadges((prev) => ({ ...prev, [key]: true }))
                                }
                                className="text-xs text-primary font-medium ml-2"
                              >
                                +{remainingCount} more
                              </button>
                            )}
                            {isExpanded && values.length > 3 && (
                              <button
                                onClick={() =>
                                  setExpandedBadges((prev) => ({ ...prev, [key]: false }))
                                }
                                className="text-xs text-primary font-medium ml-2"
                              >
                                Show Less
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Show No Records Found if no data */}
                  {filteredPeople.length === 0 ? (
                    <div className="flex items-center justify-center text-center text-foreground text-md h-[60%] font-medium w-full">
                      <Nodata />
                    </div>
                  ) : (
                    <>
                      <ProfileCardWrapper
                        onClick={onClickRow}
                        data={showAll ? filteredPeople : filteredPeople.slice(0, 8)}
                        loading={isLoading}
                        // className='font-sans grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'
                        // cardsPerRow={3}
                        render={(person, index) => {
                          const { status, color, bg } = getStatusMeta(person.allocation_status);
                          const { percentage, bgColor } = getUtilizedStatus(person.utilization_percentage);

                          return (
                            <ProfileCard
                              onclick={() => onClickRow(person?.employeeid)}
                            >
                              <ProfileCard.Header
                                avatar={person?.profile_url}
                                name={person.fullname || "N/A"}
                                role={person.rolename || "N/A"}
                                status={status || "Default"}
                                color={color || '#8a8cd9'}
                                bg={bg || '#e5e5ff'}
                              />
                              <ProfileCard.Info
                                location={person.geography === "India" ? "Offshore" : "Onshore" || "N/A"}
                                department={person.departmentname || "N/A"}
                                band={getBandLabel(person?.band_,true)}
                                rollOff={person?.project_end_date || "N/A"}
                                color={person?.color || "red"}
                              />
                              <ProfileCard.Utilization value={percentage} color={bgColor} />
                              <ProfileCard.CurrentProject
                                project={person?.current_projects || []}
                                showIcon={true}
                                employeeId={person?.employeeid}
                                getPeopleData={getPeopleData}
                                notesLoader={notesLoader[person.employeeid] || false}
                                benchNotes={person?.bench_notes}
                                isAuthenticated={isAuthenticated}
                              />
                            </ProfileCard>
                          );
                        }}
                      />
                      {toggleView === "Grid" && filteredPeople.length > 8 && !showAll && (
                        <div className="flex justify-center py-4 w-full mt-4">
                          {isLoadingMore ? (
                            <LoaderComponent height="5vh" />
                          ) : (
                            <button
                              onClick={handleToggleViewMore}
                              className="text-sm font-medium text-primary hover:text-blue-800 transition-colors"
                            >
                              View More
                            </button>
                          )}
                        </div>
                      )}

                    </>
                  )}
                </div>
              ) : (
                <div className='w-full'>
                  <TabTable
                    currentTab={currentTab}
                    currentTabIndex={currentTabIndex} // <- should be the actual index
                    tabValueCounts={tabValueCounts}
                    setTabValueCounts={setTabValueCounts}
                    filteredPeople={filteredPeople}
                    profileData={profileData}
                    selectedTab={isPassSelectedTab}
                    onExport={() => setOpenDownloadModal(true)}
                    forwardref={tableforwardref}
                    refreshData={getPeopleData}
                    notesLoader={notesLoader}
                    isAuthenticated={isAuthenticated}
                    columnVisibility={columnVisibility}
                    setColumnVisibility={setColumnVisibility}
                    setRefData={setRefData}
                  />
                </div>
              )}

            </div>
        <ExportModalWrapper
          openDownloadModal={openDownloadModal}
          handleExportClose={handleExportClose}
          handleExportConfirm={handleExportConfirm}
          exportList={exportList}
        />
          </FullScreenWrapper>
        </div>

      </ContentWrapper>
    </PageWrapper>
  );
};

export default RMPeople;
